import { combineReducers } from "redux";
import navigationReducer from "./navigation-reducer";
import statusReducer from "./status-reducer";

export default combineReducers({
	navigation: navigationReducer,
	status: statusReducer,
});
